import * as React from 'react';
import { ChevronLeft } from '../icons/Chevrons';
import DesktopChevronLeft from './desktop-backbutton-chevron.svg';
import './backButton.module.scss';
import { GlobalStatesV3 } from '../../../states/GlobalStatesV3';

type Props = {
    className?: string;
    styleName?: string;
    onClick?: () => any;
};

export const BackButton = ({ onClick = GlobalStatesV3.routing.goBack, className = undefined }: Props) => (
    <div styleName="button-wrapper" className={className} onClick={onClick}>
        {GlobalStatesV3.viewport.isDesktop ? (
            <img styleName="desktop-icon" src={DesktopChevronLeft} />
        ) : (
            <div styleName="icon-wrapper">
                <ChevronLeft styleName="icon" />
            </div>
        )}戻る
    </div>
);
